<template>
	<section class="xilografia inner-screen">
		<video-page :data="data"></video-page>
	</section>	
</template>

<script>
import VideoPage from './VideoPage'
import karbon from '../assets/img/tools/karbon.png';
import gouza from '../assets/img/tools/gouza.png';
import rolo from '../assets/img/tools/rolo.png';
import spoon from '../assets/img/tools/spoon.png';
import video1 from './../assets/videos/woodcut/woodcut_draw001.mp4';
import video2 from './../assets/videos/woodcut/woodcut_cut002.mp4';
import video3 from './../assets/videos/woodcut/woodcut_ink003.mp4';
import video4 from './../assets/videos/woodcut/woodcut_print004.mp4';

export default {
  name: 'xilografia',
  components: {
    VideoPage
  },
  created: function() {
      window.document.title = "ΧΑΡΑΚΤΙΚΗ - ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ";
  },
  data () {
    return {
      data: {
      	stepcount: 4,
      	step_icons: [
      		{src: karbon},
      		{src: gouza},
      		{src: rolo},
			{src: spoon}
      	],
      	videos: [
      		{src: video1},
      		{src: video2},
      		{src: video3},
      		{src: video4},
      	],
      	description: [
      		{text: 'Ο χαράκτης σχεδιάζει τη σύνθεση που επιθυμεί και τη μεταφέρει (με καρμπόν π.χ.) στην ξύλινη πλάκα που πρόκειται να χαράξει. '},
      		{text: 'Με ειδικά εργαλεία (γούζες, σκαρπέλα) χαράζει το σχέδιο στην ξύλινη πλάκα. Σκοπός της χάραξης είναι η αφαίρεση των λευκών μερών του σχεδίου.'},
      		{text: 'Μελανώνει με έναν κύλινδρο λαστιχένιο μελανώματος την ξύλινη επιφάνεια. Τα σημεία που αφαιρέθηκαν δεν θα μελανωθούν, παρά μόνο τα μέρη της ξύλινης επιφάνειας που παρέμειναν αχάρακτα.'},
      		{text: 'Στη συνέχεια τοποθετεί ένα φύλλο χαρτί στην πλάκα και το πιέζει ομοιόμορφα με ένα κοίλο εργαλείο(έστω με ένα κουτάλι) με σκοπό να τυπωθεί το μελάνι . Το τυπωμένο αυτό χαρτί είναι το χαρακτικό και η διαδικασία επαναλαμβάνεται τόσες φορές όσα και τα χαρακτικά-αντίτυπα που επιθυμεί να τυπώσει ο χαράκτης. '},
      	]
      }
    }
  },
  mounted: function() {
      this.$emit('hideLoader')
  },
}
</script>


// WEBPACK FOOTER //
// Xilografia.vue?5507dd20